module.exports = __webpack_public_path__ + "sound.svg?f2651f4b33bb569dc3a64c18675e9969";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound.svg
// module id = 115
// module chunks = 0